<template>
  <div class="edit-focus">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Edit Destination</h2>
      <div class="ico ico-close" @click="$emit('close-dashcard')">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="14.2222"
                height="14.2222"
                fill="white"
                transform="translate(8.88867 8.88889)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="prefix-textarea mt-24">
      <span class="prefix"> <label for="first">I shall</label></span>
      <input type="text" v-model="updatedFocus.ishall" rows="2" id="first" />
    </div>
    <div class="prefix-textarea">
      <span class="prefix"><label for="second">so that</label></span
      ><textarea v-model="updatedFocus.sothat" rows="2" id="second"></textarea>
    </div>
    <button
      class="btn btn-primary btn-sm collapsed"
      @click="$emit('updateFocus', updatedFocus)"
    >
      Update
    </button>
  </div>
</template>

<script>
export default {
  props: {
    focus: Object
  },
  data() {
    return {
      updatedFocus: {
        ishall: this.focus.destination.text1,
        sothat: this.focus.destination.text2
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.mt-24 {
  margin-top: 24px;
  margin-bottom: 14px;
}
.edit-focus {
  padding: 24px;
  position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
}
.prefix-textarea {
  position: relative;
  .prefix {
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    // padding-left: 10px;
    color: #cbcbcb;
    position: absolute;
    background-color: #fff;
  }
  input,
  textarea {
    border-radius: 0;
    width: 100%;
    height: unset;
    text-indent: 62px;
    font-size: 16px;
    line-height: 22px;
    resize: none;
    color: #5b606c;
    border: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}
h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  text-align: center;
}
</style>
